import React from "react";
import styled from "styled-components";

const SkeletonWrapper = styled.div`
  display: flex;
  gap: 25px;
  padding: 20px 0;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  @media (max-width: 576px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }
`;

const SkeletonCard = styled.div`
  flex: 0 0 calc(20% - 20px);
  min-width: 160px;
  height: 240px;
  background: #f0f0f0;
  border-radius: 8px;
  overflow: hidden;
  position: relative;

  @media (max-width: 768px) {
    flex: 1;
    height: 200px;
  }

  @media (max-width: 576px) {
    height: 180px;
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(90deg, #f0f0f0 0%, #e0e0e0 50%, #f0f0f0 100%);
    background-size: 200% 100%;
    animation: shimmer 2s infinite;
  }

  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }

  @media (max-width: 1200px) {
    flex: 0 0 calc(25% - 19px);
    min-width: 140px;
    height: 200px;
  }

  @media (max-width: 1024px) {
    flex: 0 0 calc(33.33% - 17px);
    min-width: 150px;
    height: 220px;
  }
`;

const CategorySkeleton = ({ count = 6 }) => {
  return (
    <SkeletonWrapper>
      {Array.from({ length: count }).map((_, index) => (
        <SkeletonCard key={index} />
      ))}
    </SkeletonWrapper>
  );
};

export default CategorySkeleton;
